import { Injectable, inject } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import { PlatformChartService } from '@data/_generated-api/platform-api/services/platform-chart.service';
import { PlatformChartCycleMomentsDto } from '@data/_generated-api/platform-api/models/platform-chart-cycle-moments-dto';

/** Enige laag die het cycle-moments-endpoint kent (patroon HdChartGroupService). */
@Injectable({ providedIn: 'root' })
export class HdChartCyclesService {
  private readonly chartApi = inject(PlatformChartService);

  async getCycleMoments(chartId: string, solarReturnYear?: number): Promise<PlatformChartCycleMomentsDto> {
    const result = await firstValueFrom(this.chartApi.getChartsIdCycleMoments({ id: chartId, solarReturnYear }));
    if (!result?.isValid || !result.value) {
      throw new Error(result?.simpleMessage || 'De cycle-momenten konden niet geladen worden.');
    }
    return result.value;
  }
}
